import React from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'

const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
	width: 100%;
`
const Section = styled.section`
	&:nth-of-type(odd) {
		background-color: ${({ theme }) => theme.colors.gray[100]};
	}
`
const SectionContainer = styled.div`
	${({ theme }) => theme.maxWidth.L};
	color: ${({ theme }) => theme.colors.gray[700]};
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 0 auto;
	padding: 3rem 0;
	width: 90%;

	p,
	li {
		${({ theme }) => theme.fonts.primary};
		font-size: 1.125rem;
		letter-spacing: 1px;
		line-height: 27px;
	}

	h3 {
		${({ theme }) => theme.fonts.bold};
		font-size: 1.125rem;
	}

	ol {
		margin: auto 0 auto auto;
		width: 85%;

		${({ theme }) => theme.MQ.M} {
			margin: auto;
			max-width: 600px;
			width: 100%;
		}

		${({ theme }) => theme.MQ.XL} {
			max-width: 800px;
		}

		li {
			${({ theme }) => theme.fonts.primary};
			color: ${({ theme }) => theme.colors.gray[600]};
			margin: 1.5rem 0;

			&::marker {
				${({ theme }) => theme.fonts.primaryBlack};
				color: ${({ theme }) => theme.colors.tertiary};
				font-size: 4.625rem;
				letter-spacing: 4.11px;
				width: 86px;
			}

			span {
				display: inline-block;
				font-size: 1.25rem;
				margin-left: 1rem;
				max-width: 700px;

				${({ theme }) => theme.MQ.M} {
					font-size: 1.5rem;
					margin-left: 1.5rem;
				}
			}
		}
	}
`
const SectionTitle = styled.h2`
	${({ theme }) => theme.fonts.primarySemiBold};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 2rem;
	letter-spacing: -0.53px;
	line-height: 48px;
	margin: 1rem 0 2rem;
	max-width: inherit;
	text-align: left;

	&.listHeader {
		margin: auto;
		max-width: 700px;
		text-align: center;
	}
`
BuyingGuideSection.propTypes = {
	sections: array.isRequired,
}

/**
 * Buying Guide section for Leave Behind Page
 * Consists of 3 sections
 *
 * @param {Array} props.sections - array of sections
 */
function BuyingGuideSection({ sections }) {
	return (
		<Wrapper>
			{sections.map(({ content, id, isListHeader, title }) => {
				return (
					<Section key={id}>
						<SectionContainer>
							<SectionTitle {...(isListHeader && { className: 'listHeader' })}>{title}</SectionTitle>
							<div dangerouslySetInnerHTML={{ __html: content }} />
						</SectionContainer>
					</Section>
				)
			})}
		</Wrapper>
	)
}

export default BuyingGuideSection
